module.exports = __webpack_public_path__ + "aa8688cf87ba388b73ccaa006913f59f.svg";